export default "__VITE_ASSET__Czc7_1QV__"